import { useState, useCallback, useMemo } from "react";

export function useSortableBoard(columns) {
  const dragCardInitData = useMemo(() => {
    return columns?.filter(item=>!item?.omit)?.map((col) => ({
      id: col.id,
      label: col.id==='mar_as_read'?'Mark As Read':col.name,
      checked: true,
    }));
  }, [columns]); // ← only runs once

  const [board, setBoard] = useState({
    columns: [
      {
        id: 1,
        cards: [...dragCardInitData],
      },
    ],
  });

  const computedColumns = useMemo(() => {
        if (!board || !board.columns || !board.columns[0] || !board.columns[0].cards) {
            return columns;
        }
        const items = board.columns[0].cards;
        const checkedItemIds = items.filter(item => item.checked).map(item => item.id);
        return columns
            .filter(col => items.some(item => item.id === col.id && item.checked))
            .sort((a, b) => checkedItemIds.indexOf(a.id) - checkedItemIds.indexOf(b.id));
    }, [board,setBoard,columns]);
    
  const handleClickResetsortableHeading = useCallback(() => {
    setBoard({
      columns: [
        {
          id: 1,
          cards: [...dragCardInitData],
        },
      ],
    });
  }, [dragCardInitData]);

  return {
    board,
    setBoard,
    handleClickResetsortableHeading,
    dragCardInitData,
    computedColumns
  };
}
